import React from "react";
import { Container, Row, Col, CardBody, Card } from "reactstrap";
import { Link } from "react-router-dom";
import { animationPricing } from "../design/DummyData";
import "../../sass/design.scss";
import FAQAccordion from "../../../components/FAQAccordion";
import TextSlicer from "../../../components/TextSlicer";
import MetaData from "../../../components/MetaData";
import GoogleReviewSection from "../../../components/GoogleReviewSection";

export const videoFaq1 = [
  "Video editing and marketing require strong planning and a well-structured narrative.",
  "We provide complete video solutions tailored for your business.",
  "Our services include:",
  "• Scriptwriting",
  "• Pre-production",
  "• Editing and post-production",
  "• Graphics creation",
  "• YouTube Marketing",
  "• Video SEO",
  "• AI-based enhancements",
];

export const videoFaq2 = [
  "We use industry-standard tools for high-quality output:",
  "• Adobe Premiere Pro",
  "• CapCut Pro",
  "• Filmora",
  "• Advanced AI tools",
];

export const videoFaq3 = [
  "Video content plays a crucial role in both local and international marketing strategies.",
  "Key insights about video marketing:",
  "• 50% of consumers feel more confident purchasing after watching product videos.",
  "• Users spend more than 2 minutes on websites with video content.",
  "• There is a 64% higher chance of purchase after watching videos.",
  "• Videos have a 50% higher chance of ranking on the first page.",
  "• 74% of people buy products after watching explanatory videos.",
];

const summary = `Softorithm's comprehensive 2D animation and video services combine artistic creativity with technical excellence to deliver engaging visual content that effectively communicates your message and enhances your brand presence across all digital platforms.`;

const Animations = () => {
  const handleButtonClick = () => {
    // Handle button click - you can navigate to a specific page or perform any action
    console.log("See Our Work button clicked");
  };

  return (
    <div className="design">
      <MetaData
        metaTitle={"Video Editing Marketing"}
        metaDescription={
          "At Softorithm, we pride ourselves on providing exceptional web development, graphic design, UI/UX design, and digital marketing services through our team of passionate professionals."
        }
      />

      {/* Section 1 - Hero with Google Review */}
      <GoogleReviewSection
        title="Best Video Editing & Marketing Services"
        subtitle="Creative animation, audio editing, and video production services that bring your ideas to life. Expert storytelling through visual content trusted by businesses worldwide for over 12 years."
        buttonText="See Our Work"
        onButtonClick={handleButtonClick}
        companyName="Softorithm"
      />

      <div className="page_body">
        <div className=" mt-5">
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="text-center mb-4 pb-2 about_rgt_cont">
                <h4 className="fw-semibold fs-22 mb-4">
                  Increase Your Web Conversion Rates <br></br>Up to 34% With
                  Video Marketing
                </h4>
                <TextSlicer
                  text={`YouTube is the biggest video sharing platform on the internet. Users all over the world including the businesses have their own account on YouTube in which they upload content. Web pages that advertise through videos on YouTube have experienced an increase of 157% in organic traffic.
                 `}
                />
                <TextSlicer
                  text={`Incorporating videos into your business marketing strategy can greatly enhance your exposure to a wider audience. We offer our services to assist you in this regard. Our team of expert marketers will assist you in creating engaging video content to increase your brand awareness and audience reach.
                 `}
                />
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col xl={9}>
              <Row className="justify-content-center">
                {(animationPricing || []).map((price2, key) => (
                  <Col md={6} lg={4} xl={4} key={key}>
                    <Card className="pricing-box ribbon-box right">
                      <CardBody className="p-4 m-2">
                        <div className="d-flex align-items-start">
                          <div className="flex-grow-1 me-3">
                            <h5 className="mb-1 fw-semibold">{price2.type}</h5>
                            <p className="text-muted mb-0">{price2.purpose}</p>
                          </div>
                          <div className="avatar-sm flex-shrink-0">
                            <div className="avatar-title bg-light rounded-circle text-primary">
                              <i className={"fs-20 " + price2.icon}></i>
                            </div>
                          </div>
                        </div>

                        <hr className="my-4 text-muted" />
                        <div className="scrollable-list">
                          <ul className="list-unstyled text-muted vstack gap-3">
                            {(price2.points || []).map((point, key) => (
                              <li key={key}>
                                <div className="d-flex">
                                  <div className="flex-shrink-0 text-success me-1">
                                    <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                  </div>
                                  <div className="flex-grow-1">{point}</div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>

                        <div className="mt-3 pt-2">
                          <Link
                            to="/contact-us"
                            className={`btn btn-success w-100`}
                          >
                            Get Quote
                          </Link>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Section 7 - CTA Section */}
          <section className="erp_cta_section">
            <Container>
              <Row className="align-items-center">
                <Col lg={8} md={7} sm={12} className="mb-3 mb-md-0">
                  <p className="erp_cta_text">
                    Get in touch with us to discuss the details regarding your
                    digital platform and the services we can provide for future
                    web application development. We are happy to be of service!
                  </p>
                </Col>
                <Col
                  lg={4}
                  md={5}
                  sm={12}
                  className="text-center text-md-center"
                >
                  <button
                    type="button"
                    className="erp_cta_btn"
                    onClick={handleButtonClick}
                  >
                    Call Us Today!
                  </button>
                </Col>
              </Row>
            </Container>
          </section>

          <div className="container mt-5">
            <div
              className="faq_section py-3"
              style={{ backgroundColor: "var(--body-bg-color, #f8f9fa)" }}
            >
              <Container>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="faq_header text-center mb-5">
                      <h2 className="mb-3">Frequently Asked Questions</h2>
                    </div>
                    <FAQAccordion
                      faqData={[
                        {
                          question:
                            "How can we help you create engaging video editing content?",
                          points: videoFaq1,
                        },
                        {
                          question: "What tools do you use for video editing?",
                          points: videoFaq2,
                        },
                        {
                          question:
                            "What is your content creation strategy for local and international markets?",
                          points: videoFaq3,
                        },
                      ]}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Animations;
